import ContainerType from "./container-type.component";

export default ContainerType;
